/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable max-params */
import _ from 'lodash';
import { getClientEndFilteredRow, getClientEndOperationRow } from './DataTableRowUtil';
import { notEqualCheck } from '../../utils/FsUtil';
import ExpandableType from '../../constants/ExpandableType';

export const SORTING = {
  asc: {
    name: 'asc',
    desc: 'ascending',
    text: 'A-Z',
    type: 'natural',
  },
  desc: {
    name: 'desc',
    desc: 'descending',
    text: 'Z-A',
    type: 'natural',
  },
  latest: {
    name: 'latest',
    desc: 'latest',
    text: 'Newest',
    type: 'date',
  },
  oldest: {
    name: 'oldest',
    desc: 'oldest',
    text: 'Oldest',
    type: 'date',
  },
};

export const getSelectedRowId = (tableData) => Object.keys(
  tableData.selectedRows).filter((key) => tableData.selectedRows[key] === true);

export const getSelectedRowCnt = (tableData) => getSelectedRowId(tableData).length;

// eslint-disable-next-line max-params
export const onPageChangeHelper = (tableData, itemsPerPage, newPageNumber, setTableData) => {
  const newTableData = { ...tableData };
  if (newTableData.clientEndOperation) {
    newTableData.showLoader = false;
  } else {
    newTableData.showLoader = true;
  }
  if (newPageNumber) {
    newTableData.currentPage = newPageNumber;
  }
  if (itemsPerPage) {
    newTableData.itemsPerPage = itemsPerPage;
  }
  setTableData(newTableData);
  return newTableData;
};
export const onHeaderRowCheckChangeHelperV2 = (
  tableData,
  data,
  setTableData,
  disableCheckbox,
  singleRowSelect
  // eslint-disable-next-line max-params
) => {
  const newTableData = { ...tableData };
  const rowData = [];
  if (tableData.clientEndOperation) {
    const clientSideFilteredRow = getClientEndFilteredRow(tableData);
    // eslint-disable-next-line no-unused-vars
    const rowsForClientSideTable = getClientEndOperationRow(clientSideFilteredRow, tableData);

    clientSideFilteredRow.forEach((row) => {
      if (!singleRowSelect && getSelectedRowCnt(newTableData) < tableData.maxRowSelection) {
        let isCheckable = true;
        const newRow = { ...row };
        if (typeof disableCheckbox === 'function') {
          isCheckable = !disableCheckbox(newRow);
        }
        if (isCheckable) {
          newRow.selected = !data.checked;
          newTableData.selectedRows[newRow[tableData.rowKeyCol]] = newRow.selected;
          newTableData.selectedRowsData[newRow[tableData.rowKeyCol]] = newRow;
        }
        rowData.push(newRow);
        newTableData.rows = rowData;
      } else {
        rowData.push(row);
        newTableData.rows = rowData;
      }
    });
  } else {
    tableData.rows.forEach((row) => {
      if (!singleRowSelect && getSelectedRowCnt(newTableData) < tableData.maxRowSelection) {
        let isCheckable = true;
        const newRow = { ...row };
        if (typeof disableCheckbox === 'function') {
          isCheckable = !disableCheckbox(newRow);
        }
        if (isCheckable) {
          newRow.selected = !data.checked;
          newTableData.selectedRows[newRow[tableData.rowKeyCol]] = newRow.selected;
          newTableData.selectedRowsData[newRow[tableData.rowKeyCol]] = newRow;
        }
        rowData.push(newRow);
        newTableData.rows = rowData;
      } else {
        rowData.push(row);
        newTableData.rows = rowData;
      }
    }

    );
  }
  setTableData(newTableData);
  return newTableData;
};
export const onHeaderRowCheckChangeHelper = (
  tableData,
  data,
  setTableData,
  disableCheckbox
  // eslint-disable-next-line max-params
) => {
  const newTableData = { ...tableData };
  const rowData = [];
  if (tableData.clientEndOperation) {
    const clientSideFilteredRow = getClientEndFilteredRow(tableData);
    const rowsForClientSideTable = getClientEndOperationRow(clientSideFilteredRow, tableData);
    clientSideFilteredRow.forEach((row) => {
      if (rowsForClientSideTable.includes(row)) {
        let isCheckable = true;
        const newRow = { ...row };
        if (typeof disableCheckbox === 'function') {
          isCheckable = !disableCheckbox(newRow);
        }
        if (isCheckable) {
          newRow.selected = !data.checked;
          newTableData.selectedRows[newRow[tableData.rowKeyCol]] = newRow.selected;
          newTableData.selectedRowsData[newRow[tableData.rowKeyCol]] = newRow;
        }
        rowData.push(newRow);
      } else {
        const newRow = { ...row };
        rowData.push(newRow);
      }
    });
  } else {
    tableData.rows.forEach((row) => {
      let isCheckable = true;
      const newRow = { ...row };
      if (typeof disableCheckbox === 'function') {
        isCheckable = !disableCheckbox(newRow);
      }
      if (isCheckable && getSelectedRowCnt(newTableData) <= tableData.maxRowSelection) {
        newRow.selected = !data.checked;
        newTableData.selectedRows[newRow[tableData.rowKeyCol]] = newRow.selected;
        newTableData.selectedRowsData[newRow[tableData.rowKeyCol]] = newRow;
      }
      rowData.push(newRow);
    });
  }
  newTableData.rows = rowData;
  setTableData(newTableData);
  return newTableData;
};

// eslint-disable-next-line max-params
export const onRowCheckChangeHelper = (tableData, data, setTableData, rowsForClientSideTable) => {
  const newTableData = { ...tableData };
  let rowIdx = newTableData.rows.findIndex((r) => r[tableData.rowKeyCol] === data.id);
  if (rowIdx < 0) {
    const keys = data.id.split('-');
    rowIdx = keys[keys.length - 1];
    if (tableData.clientEndOperation) {
      rowIdx = newTableData.rows.findIndex(
        (r) => r[tableData.rowKeyCol] === rowsForClientSideTable[rowIdx][tableData.rowKeyCol]
      );
    }
  }
  if (newTableData.singleRowSelect) {
    for (let i = 0; i < newTableData.rows.length; i += 1) {
      if (newTableData.rows[i].selected) {
        newTableData.rows[i] = { ...newTableData.rows[i], selected: false };
      }
    }
    newTableData.selectedRows = {};
    newTableData.selectedRowsData = {};
  }
  if (newTableData.rows.length > rowIdx) {
    newTableData.rows[rowIdx] = { ...newTableData.rows[rowIdx], selected: !data.checked };
  }
  if (!data.checked) {
    newTableData.selectedRows[data.id] = true;
    newTableData.selectedRowsData[data.id] = newTableData.rows[rowIdx];
  } else if (newTableData.selectedRows[data.id]) {
    newTableData.selectedRows[data.id] = false;
  }
  setTableData(newTableData);
  return newTableData;
};

export const updateTableDataBasedOnUserPreference = (updatedTableData, totalRows) => {
  if (updatedTableData.preferceData) {
    let newHeaders = [];

    const headerMap = Object.fromEntries(updatedTableData.headers.map((h) => [h.sNo, h]));

    if (updatedTableData.preferceData.order?.length > 0) {
      // eslint-disable-next-line no-unused-vars
      updatedTableData.preferceData.order.forEach((sNo, idx) => {
        newHeaders.push(headerMap[sNo]);
        //       headerMap[sNo].sNo = (idx+1);
      });
    } else {
      newHeaders = updatedTableData.headers;
    }

    // eslint-disable-next-line no-unused-expressions
    updatedTableData.preferceData.inactiveHeader?.forEach((sNo) => {
      const headerToUpdate = headerMap[sNo];
      if (headerToUpdate?.display === true) {
        headerToUpdate.display = false;
        headerToUpdate.filter = '';
      }
    });

    // eslint-disable-next-line no-unused-expressions
    updatedTableData.preferceData.activeHeader?.forEach((sNo) => {
      const headerToUpdate = headerMap[sNo];
      if (headerToUpdate?.display === false) {
        headerToUpdate.display = true;
      }
    });

    if (updatedTableData.preferceData.itemsPerPage) {
      if (updatedTableData.itemsPerPage !== updatedTableData.preferceData.itemsPerPage) {
        updatedTableData.itemsPerPage = updatedTableData.preferceData.itemsPerPage;
        const maxPage = Math.ceil(totalRows / updatedTableData.itemsPerPage);
        updatedTableData.currentPage = updatedTableData.currentPage > maxPage ? maxPage
          : updatedTableData.currentPage;
        console.log('AFTER updatedTableData.currentPage', updatedTableData.currentPage);
      }
    }

    if (updatedTableData.preferceData.sortDirection) {
      if (updatedTableData.sortDirection !== updatedTableData.preferceData.sortDirection) {
        updatedTableData.sortDirection = updatedTableData.preferceData.sortDirection;
      }
    }

    if (updatedTableData.preferceData.sortBy) {
      if (updatedTableData.sortBy !== updatedTableData.preferceData.sortBy) {
        updatedTableData.sortBy = updatedTableData.preferceData.sortBy;
      }
    }

    updatedTableData.headers = newHeaders;
  }

  return updatedTableData;
};

export const onSortClickHelper = (tableData, data, setTableData) => {
  const newTableData = { ...tableData };
  newTableData.sortDirection = newTableData.sortBy === data && newTableData.sortDirection === 'asc' ? 'desc' : 'asc';
  newTableData.sortBy = data;
  newTableData.currentPage = 1;
  if (newTableData.clientEndOperation) {
    newTableData.showLoader = false;
  } else {
    newTableData.showLoader = true;
  }
  setTableData(newTableData);
  return newTableData;
};

export const onTableSettingResetToDefaultHelper = (
  newTableData,
  newPrefrenceData,
  setTableData
) => {
  newTableData.preferceData = newPrefrenceData;
  updateTableDataBasedOnUserPreference(newTableData);
  if (newTableData.clientEndOperation) {
    newTableData.showLoader = false;
  } else {
    newTableData.showLoader = true;
  }
  setTableData(newTableData);
  return newTableData;
};

// TODO :: looks back this once
export const onTableSettingsChangeHelper = (
  tableData,
  newPrefrenceData,
  setTableData,
  totalRows
) => {
  const newTableData = { ...tableData };
  // newTableData.rows = [...newTableData.rows];
  // newTableData.selectedRows = {...newTableData.selectedRows};
  // newTableData.selectedRowsData = {...newTableData.selectedRowsData};
  // newTableData.headers = [...newTableData.headers];
  newTableData.preferceData = newPrefrenceData;
  updateTableDataBasedOnUserPreference(newTableData, totalRows);
  if (newTableData.clientEndOperation) {
    newTableData.showLoader = false;
  } else {
    newTableData.showLoader = true;
  }
  setTableData(newTableData);
  return newTableData;
};

export const onFilterHelper = (tableData, filterData, setTableData) => {
  const newTableData = { ...tableData };
  //  newTableData.headers = [...newTableData.headers];
  let counter = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < newTableData.headers.length; i++) {
    if (newTableData.headers[i].display) {
      newTableData.headers[i] = { ...newTableData.headers[i], filter: filterData[counter].trim() };
      // eslint-disable-next-line no-plusplus
      counter++;
    }
  }
  newTableData.showLoader = !newTableData.clientEndOperation;
  newTableData.currentPage = 1;
  setTableData(newTableData);
  return newTableData;
};

export const onFilterResetHelper = (tableData, setTableData) => {
  const newTableData = { ...tableData };
  newTableData.headers = [...newTableData.headers];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < newTableData.headers.length; i++) {
    newTableData.headers[i] = { ...newTableData.headers[i], filter: '' };
  }
  newTableData.showLoader = !newTableData.clientEndOperation;
  newTableData.currentPage = 1;
  setTableData(newTableData);
  return newTableData;
};

export const onFilterIconClickedHelper = (tableData, displayFilter, setTableData) => {
  const newTableData = { ...tableData };
  newTableData.showFilter = displayFilter;
  setTableData(newTableData);
  return newTableData;
};

export const preprocessExpandableTableData = (tableRows, headers, expandableCol) => {
  const newTableRows = _.cloneDeep(tableRows);
  const getExpandableHeader = (headers_, col) => headers_.filter((h) => h.id === col).map((h) => h);
  const expandableHeader = getExpandableHeader(headers, expandableCol)?.shift();
  const groupByExpandableCol = _.groupBy(
    newTableRows,
    (row) => (expandableHeader.parentFun ? expandableHeader.parentFun(row[expandableCol]) : String(row[expandableCol]).split('T')[0])
  );
  const data = [];
  let totalRows = 0;
  Object.values(groupByExpandableCol).forEach((val) => {
    const newRow = {};
    const norCol = {};
    const expCols = [];
    let rowData = {};
    val.forEach((x) => {
      rowData = { ...x };
      totalRows += 1;
      x[expandableCol] = expandableHeader.childFun(x[expandableCol]);
      expCols.push(x);
    });
    if (expCols) {
      norCol[expandableCol] = rowData[expandableCol];
      newRow.columns = norCol;
      newRow.expandableColumn = expCols;
      newRow.expandable = false;
      data.push(newRow);
    }
  });
  return { data, totalRows };
};

// eslint-disable-next-line max-params
export const callAPIHelper = (updatedTableData, newRows, setTableData, isError, hyperlinkData) => {
  const newTableData = { ...updatedTableData };
  const { defaultColumn } = newTableData;
  if (!isError) {
    if (newRows) {
      if (updatedTableData?.expandable) {
        if (notEqualCheck(updatedTableData?.expandableType, ExpandableType.COMPONENT)) {
          newRows = preprocessExpandableTableData(
            newRows.data,
            updatedTableData.headers,
            updatedTableData.expandableCol
          );
        } else {
          newRows.data.forEach((row) => {
            row.expandable = false;
          });
        }
      }
      newTableData.totalRows = newRows.totalRows;
      newTableData.rows = newRows.data;
      if (hyperlinkData) {
        newTableData.hyperlinkData = hyperlinkData;
      }
      newRows.data.forEach((r) => {
        if (r.selected) {
          newTableData.selectedRows[r[updatedTableData.rowKeyCol]] = true;
          newTableData.selectedRowsData[r[updatedTableData.rowKeyCol]] = r;
        } else if (newTableData.selectedRows[r[updatedTableData.rowKeyCol]]) {
          r.selected = true;
          newTableData.selectedRowsData[r[updatedTableData.rowKeyCol]] = r;
        }
        if (defaultColumn?.hasDefaultColumn && r.default) {
          defaultColumn.selectedToggleRows[r[updatedTableData.rowKeyCol]] = true;
          defaultColumn.selectedToggleData[r[updatedTableData.rowKeyCol]] = r;
        }
      });
      newTableData.headers = [...newTableData.headers];
      newTableData.showLoader = false;
      setTableData(newTableData);
    }
  } else {
    newTableData.showError = true;
    setTableData(newTableData);
  }
  return newTableData;
};

export const populatePrefrenceBasedOnCurrentDefault = (tableData) => {
  tableData.preferceData = {
    activeHeader: tableData.headers.filter((h) => h.display === true).map((h) => h.sNo),
    inactiveHeader: tableData.headers.filter((h) => h.display === false).map((h) => h.sNo),
    order: tableData.headers.map((h) => h.sNo),
    itemsPerPage: tableData.itemsPerPage,
    sortDirection: tableData.sortDirection,
    sortBy: tableData.sortBy,
    tableNm: tableData.tableNm,
  };
};

export const updatedTableDataForPreference = (updatedTableData, loginData) => {
  if (loginData?.preferenceData?.tableData) {
    updatedTableData.preferceData = loginData?.preferenceData?.tableData.find(
      (pd) => pd.tableNm === updatedTableData.tableNm
    );
    updateTableDataBasedOnUserPreference(updatedTableData);
  } else {
    populatePrefrenceBasedOnCurrentDefault(updatedTableData);
  }
};

export const getSelectedRows = (tableData) => getSelectedRowId(
  tableData).map((key) => tableData.selectedRowsData[key]);

export const isAnyRowSelect = (tableData) => Object.keys(
  tableData.selectedRows).filter((key) => tableData.selectedRows[key] === true).length > 0;

export const resetTableSelections = (context) => {
  const newTableData = { ...context.tableData };
  // eslint-disable-next-line no-return-assign
  newTableData.rows.forEach((r) => (r.selected = false));
  newTableData.selectedRows = [];
  newTableData.selectedRowsData = [];
  context.setTableData(newTableData);
};

export const getClonedDefaultSettings = (tableData) => {
  const clonedDefaultSetting = {};
  clonedDefaultSetting.sortBy = tableData.sortBy;
  clonedDefaultSetting.itemsPerPage = tableData.itemsPerPage;
  clonedDefaultSetting.tableNm = tableData.tableNm;
  clonedDefaultSetting.sortDirection = tableData.sortDirection;
  clonedDefaultSetting.hyperlinkData = tableData.hyperlinkData;
  clonedDefaultSetting.headers = _.cloneDeep(tableData.headers);
  return clonedDefaultSetting;
};

export const resetTableData = (tableData) => {
  // eslint-disable-next-line no-param-reassign
  tableData.selectedRows = [];
  // eslint-disable-next-line no-param-reassign
  tableData.selectedRowsData = [];
  // eslint-disable-next-line no-param-reassign
  tableData.showFilter = false;
  tableData.headers.forEach((h) => {
    if (h) {
      h.filter = '';
    }
  });
};

// eslint-disable-next-line max-params
export const handleToggleChangeHelper = (tableData, data, setTableData, rowsForClientSideTable) => {
  const newTableData = { ...tableData };
  const { defaultColumn } = newTableData;
  let rowIdx = newTableData.rows.findIndex((r) => r[tableData.rowKeyCol] === data.id);
  if (rowIdx < 0) {
    const keys = data.id.split('-');
    rowIdx = keys[keys.length - 1];
    if (tableData.clientEndOperation) {
      rowIdx = newTableData.rows.findIndex(
        (r) => r[tableData.rowKeyCol] === rowsForClientSideTable[rowIdx][tableData.rowKeyCol]
      );
    }
  }
  if (defaultColumn.singleToggleSelect) {
    for (let i = 0; i < newTableData.rows.length; i += 1) {
      if (newTableData.rows[i].default) {
        newTableData.rows[i] = { ...newTableData.rows[i], default: false };
      }
    }
    defaultColumn.selectedToggleRows = {};
    defaultColumn.selectedToggleData = {};
  }
  newTableData.rows[rowIdx] = { ...newTableData.rows[rowIdx], default: !data.toggle };

  if (newTableData.rows[rowIdx].default) {
    defaultColumn.selectedToggleRows[data.id] = true;
    defaultColumn.selectedToggleData[data.id] = newTableData.rows[rowIdx];
  } else if (defaultColumn.selectedToggleRows[data.id]) {
    defaultColumn.selectedToggleRows[data.id] = false;
  }
  setTableData(newTableData);
  return newTableData;
};

export const getSelectedToggleRowId = (tableData) => Object.keys(
  tableData.defaultColumn.selectedToggleRows).filter(
  (key) => tableData.defaultColumn.selectedToggleRows[key] === true
);

export const getSelectedToggleRowCnt = (tableData) => getSelectedToggleRowId(tableData).length;

export const getSelectedToggleRows = (tableData) => getSelectedToggleRowId(
  tableData).map((key) => tableData.defaultColumn.selectedToggleData[key]);

export const isAnyToggleRowSelect = (tableData) => Object.keys(
  tableData.defaultColumn.selectedToggleRows).filter(
  (key) => tableData.defaultColumn.selectedToggleRows[key] === true
).length > 0;
